import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { routeNames } from '../../constants/routes';
import { Battle, CustomPlace, Geolocation, Random, RandomRegionalPlace, RegionCity } from '../../containers/games';
import { HeraldryGame } from '../../containers/games/HeraldryGame';
import { Help, Home, Info, NotFound, Result } from '../../pages';
import { BiggerCity, BlindMap, MunicipalityRegion, Peaks, ProtectedAreas, RegionShape, Rivers, Unesco } from '../../pages/quiz';
import { CookiesPage } from '../../pages/Cookies';
import { DonationPage } from '../../pages/DonationPage';
import { EndIsNear } from '../../pages/EndIsNear';
import { PlacesUpload } from '../../pages/PlacesUpload';
import { TermsPage } from '../../pages/Terms';

const RouterSwitch = () => {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>
            <Route path={`/${routeNames.geolokace}`}>
                <Geolocation />
            </Route>
            <Route path={`/${routeNames.mesto}`}>
                <RegionCity />
            </Route>
            <Route path={`/${routeNames.nahodne}`}>
                <Random />
            </Route>
            <Route path={`/${routeNames.heraldika}`}>
                <HeraldryGame />
            </Route>
            <Route path={`/${routeNames.slepaMapaObci}`}>
                <BlindMap />
            </Route>
            <Route path={`/${routeNames.tvarKraje}`}>
                <RegionShape />
            </Route>
            <Route path={`/${routeNames.obecKrajOkres}`}>
                <MunicipalityRegion />
            </Route>
            <Route path={`/${routeNames.coJeVetsi}`}>
                <BiggerCity />
            </Route>
            <Route path={`/${routeNames.chranenaUzemi}`}>
                <ProtectedAreas />
            </Route>
            <Route path={`/${routeNames.horyAVrcholy}`}>
                <Peaks />
            </Route>
            <Route path={`/${routeNames.reky}`}>
                <Rivers />
            </Route>
            <Route path={`/${routeNames.unesco}`}>
                <Unesco />
            </Route>
            <Route path={`/${routeNames.nahodneKraj}`}>
                <RandomRegionalPlace />
            </Route>
            <Route path={`/${routeNames.vysledek}`}>
                <Result />
            </Route>
            <Route path={`/${routeNames.vlastni}`}>
                <CustomPlace />
            </Route>
            <Route path={`/${routeNames.napoveda}`}>
                <Help />
            </Route>
            <Route path={`/${routeNames.info}`}>
                <Info />
            </Route>
            <Route path={`/${routeNames.podpora}`}>
                <DonationPage />
            </Route>
            <Route path={`/${routeNames.podminky}`}>
                <TermsPage />
            </Route>
            <Route path={`/${routeNames.cookies}`}>
                <CookiesPage />
            </Route>
            <Route path={`/${routeNames.nahratMisto}`}>
                <PlacesUpload />
            </Route>
            <Route path={`/${routeNames.endIsNear}`}>
                <EndIsNear />
            </Route>
            <Route path={`/${routeNames.battle}/:battleId`}>
                <Battle />
            </Route>
            <Route path="*">
                <NotFound />
            </Route>
        </Switch>
    );
};

export default RouterSwitch;
